import { render, staticRenderFns } from "./row-edit-form.vue?vue&type=template&id=1b23e8ae&scoped=true"
import script from "./row-edit-form.vue?vue&type=script&lang=js"
export * from "./row-edit-form.vue?vue&type=script&lang=js"
import style0 from "./row-edit-form.vue?vue&type=style&index=0&id=1b23e8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23e8ae",
  null
  
)

export default component.exports